export default __webpack_public_path__ + "static/media/popup_4s.c1769b6a.png";